import { Component, OnInit } from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";

import { ButtonChangeLocationComponent } from '../button-change-location/button-change-location.component';
import { Router } from '@angular/router';
import {AuthApiService} from "../../shared/core-jpats/services/auth.service";
import {Subscription} from "rxjs";
import { EsriMarkerData } from '../../../../shared/ui-ndms/components/map-esri/map-esri.component';
import {NdmsAuthService} from "../../../../../ndms/app/shared/core-ndms/services/ndms-auth.service";

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  authSubscription: Subscription;
  bsModalRef: BsModalRef;

  // Table Configuration
  tableData: any[] = [
    {
      firstName: 'Tony',
      lastName: 'Holt'
    },
    {
      firstName: 'Bill',
      lastName: 'Bassler'
    },
    {
      firstName: 'Tony',
      lastName: 'Holt'
    },
    {
      firstName: 'Tony',
      lastName: 'Holt'
    },
    {
      firstName: 'Bill',
      lastName: 'Bassler'
    },
    {
      firstName: 'Tony',
      lastName: 'Holt'
    },
    {
      firstName: 'Tony',
      lastName: 'Holt'
    },
    {
      firstName: 'Bill',
      lastName: 'Bassler'
    },
    {
      firstName: 'Tony',
      lastName: 'Holt'
    },
    {
      firstName: 'Tony',
      lastName: 'Holt'
    },
    {
      firstName: 'Bill',
      lastName: 'Bassler'
    },
    {
      firstName: 'Tony',
      lastName: 'Holt'
    },
    {
      firstName: 'Tony',
      lastName: 'Holt'
    },
    {
      firstName: 'Bill',
      lastName: 'Bassler'
    },
    {
      firstName: 'Tony',
      lastName: 'Holt'
    },
    {
      firstName: 'Tony',
      lastName: 'Holt'
    },
    {
      firstName: 'Bill',
      lastName: 'Bassler'
    },
    {
      firstName: 'Tony',
      lastName: 'Holt'
    },
    {
      firstName: 'Tony',
      lastName: 'Holt'
    },
    {
      firstName: 'Bill',
      lastName: 'Bassler'
    },
    {
      firstName: 'Tony',
      lastName: 'Holt'
    },
  ];

  // locations: EsriMarkerData[] = [
  //   {
  //     latitude: 39.1819305,
  //     longitude: -76.8061295,
  //     title: 'Columbia FEi'
  //   },
  //   {
  //     latitude: 39.2881584,
  //     longitude: -76.6246796,
  //     title: 'R Adams Cowley Shock Trauma Center'
  //   },
  //   {
  //     latitude: 37.128109,
  //     longitude: -121.020276,
  //     title: 'Harford Memorial Hospital'
  //   }
  // ]

  // Bar Chart Configuration

  public barChartLabels:string[] = ['Medical', 'Psychiatric', 'Burns', 'Pediatrics', 'Critical Care', 'Unknown'];
  //public barChartLabels:string[] = ['1', '2', '3', '4', '5', '6'];
  public barChartData:any[] = [
    {data: [65, 59, 80, 81, 56, 55]}
  ];
  public barChartOptions:any = {
  };
  public barChartType:string = 'bar';
  public barChartLegend:boolean = false;

  // Pie Chart Configuration

  public pieChartLabels:string[] = ['Download Sales', 'In-Store Sales', 'Mail Sales'];
  public pieChartData:number[] = [300, 500, 100];
  public pieChartType:string = 'pie';
  public pieChartOptions:any = {
    legend: {
      position: 'left'
    },
    title: {
      display: true,
      text: 'Custom Chart Title'
    }
  }

  constructor(private ndmsAuthApiService: NdmsAuthService, private modalService: BsModalService, private router: Router) {

  }

  ngOnInit() {
    /*this.authSubscription = this.ndmsAuthApiService.authFinished.subscribe((finished)=>{
      if(this.ndmsAuthApiService.hasAuthenticated()){
        let buttonChangeLocationComponent = new ButtonChangeLocationComponent(this.ndmsAuthApiService,this.modalService, this.router);
        buttonChangeLocationComponent.showModal(true);
      }
    })*/
  }
  ngOnDestroy() {
    this.authSubscription.unsubscribe();
  }

}
